import React from "react";
import HeroOpen from "../../Components/HeroOpen/HeroOpen";
import OpenLiftIntro from "../../Components/OpenLiftIntro/OpenLiftIntro";
import OpenLiftHowItWorks from "../../Components/OpenLiftHowItWorks/OpenLiftHowItWorks";
import OpenLiftCompatibility from "../../Components/OpenLiftCompatibility/OpenLiftCompatibility";
import OpenLiftBenefits from "../../Components/OpenLiftBenefits/OpenLiftBenefits";
import OpenLiftDeployment from "../../Components/OpenLiftDeployment/OpenLiftDeployment";
import OpenLiftProofs from "../../Components/OpenLiftProofs/OpenLiftProofs";
import OpenLiftFAQ from "../../Components/OpenLiftFAQ/OpenLiftFAQ";
import OpenLiftConversion from "../../Components/OpenLiftConversion/OpenLiftConversion";
import "./Openlift.css"; // ⬅️ Ajoute ce CSS de page

export default function Openlift() {
  return (
    <main className="openlift-page" role="main">
      <HeroOpen />
      <OpenLiftIntro />
      <OpenLiftHowItWorks />
      <OpenLiftCompatibility />
      <OpenLiftBenefits />
      <OpenLiftDeployment />
      <OpenLiftProofs />
      <OpenLiftFAQ />
      <OpenLiftConversion />
    </main>
  );
}
